export const isInCompanyPropertyTypePage = (pageLabel: string) => {
  const result =
    pageLabel.indexOf('land') != -1 || pageLabel.indexOf('house') != -1 || pageLabel.indexOf('mansion') != -1;

  return result;
};
